/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import  Grid from '@material-ui/core/Grid';
import {
    array,
    object,
    shape,
    string,
} from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getPresentationFamily } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import CopyGrid from './Partials/CopyGrid';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const styles = (theme) => ({
    container: {
        [theme?.breakpoints?.down('sm')]: {
            maxWidth: theme?.palette?.tiers?.container?.maxWidth?.downSmall,
            margin: '0 auto',
        },
        [theme?.breakpoints?.down('md')]: {
            maxWidth: theme?.palette?.tiers?.container?.maxWidth?.downMedium,
            margin: '0 auto',
        },
        [theme?.breakpoints?.up('md')]: {
            maxWidth: 1440,
            margin: '0 auto',
        },
        [theme?.breakpoints?.up('lg')]: {
            maxWidth: 1440,
            margin: '0 auto',
        },
        '& a': {
            textDecoration: 'none',
        },
    },
    title: {
        textAlign: 'center',
    },
});

const GraphqlContactUsPage = ({
    classes,
    contactUsData,
}) => {
    const { title, page_blocks, seo = {} } = contactUsData || {};

    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <div className={classes.container}>
                <Grid container>
                    <Grid item xs={12}>
                        <h1 className={classes.title}>{title}</h1>
                    </Grid>
                    {
                        page_blocks?.map((block, index) => {
                            const blockKey = Object.keys(block)[0];
                            const key = `block${index}`;
                            switch (blockKey) {
                                case 'copy_grid':
                                    return <CopyGrid key={key} blocks={block[blockKey].copy_block} />;
                                default:
                                    return null;
                            }
                        })
                    }
                </Grid>
            </div>
        </>
    );
};

GraphqlContactUsPage.propTypes = {
    classes: object.isRequired,
    contactUsData: shape({
        title: string,
        page_blocks: array,
    }).isRequired,
};
const mapStateToProps = (state) => ({
    presentation_family: getPresentationFamily(state),
});
const enhance = compose(
    connect(mapStateToProps, null),
    withStyles(styles),
);

export default enhance(GraphqlContactUsPage);
